import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import { lazy } from 'react'

const WorkItemsPageLazy = lazy(
    () => import('pages/WorkItemManagementPage/workItemsPage')
)
const WorkItemDetailsPageLazy = lazy(
    () => import('pages/WorkItemManagementPage/workItemDetailsPage')
)

const WorkItemTaskDetailsPageLazy = lazy(
    () => import('pages/WorkItemManagementPage/workItemTaskPage')
)

//This page is opened in a new tab when an Admin clicks "Task Builder" from the Task Table header options button. 
//It provide predefined task management capabilities. Like creating, editing, deleting and changing priority order of predefined tasks.
//These predefined tasks are programatically applied/closed based on the state of the workItem.
const PredefinedTaskBuilderPageLazy = lazy(
    () => import('pages/WorkItemManagementPage/taskBuilderPage')
)

export const WorkflowPageRoutes: RouteDictionary = {
    '/': {
        redirect: '/workItems',
    },
    '/workItems': {
        component: WorkItemsPageLazy,
    },
    '/workItems/:id': {
        component: WorkItemDetailsPageLazy,
    },
    '/workItemTasks/taskbuilder': {
        component: PredefinedTaskBuilderPageLazy,
        exact: true,
    },
    '/workItemTasks/:id': {
        component: WorkItemTaskDetailsPageLazy,
    },
}
